import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Button } from 'transfix-ui/components/Button'
import { useNavContext } from 'utils/context/NavContext'
import { MenuButton } from './MenuButton'
import { MenuIcon } from './MenuIcon'

interface TopNavContainerProps {
  children: ReactNode
  showMenu?: boolean
  className?: string
  contentClassName?: string
  /**
   * @default 'middle'
   */
  zIndex?: 'middle' | 'normal'
  /**
   * @default true
   */
  showMenuIcon?: boolean
  /**
   * @default true
   */
  includeTopNavDefaultClass?: boolean
}

export const TopNavContainer: FC<TopNavContainerProps> = ({
  children,
  className: classNameProp = '',
  contentClassName: contentClassNameProp = '',
  includeTopNavDefaultClass = true,
  showMenu,
  showMenuIcon = true,
  zIndex = 'middle',
}) => {
  const { toggleNav } = useNavContext()
  const className = classNames(classNameProp, {
    'top-nav': includeTopNavDefaultClass,
    'z-index-middle': zIndex === 'middle',
  })
  const contentClassName = classNames(contentClassNameProp, 'top-nav-content')

  return (
    <header className={className}>
      {showMenu && (
        <div className='menu top-nav-menu'>
          <Button onClick={toggleNav} color='tertiary'>
            <span className='flex flex-row items-center'>
              {showMenuIcon && <MenuIcon />}
              <MenuButton />
            </span>
          </Button>
        </div>
      )}
      <div className={contentClassName}>{children}</div>
    </header>
  )
}
